module.exports = __webpack_public_path__ + "static/media/picture-(98).8260e21a.JPG";